import api from "../api/dataSource";
import { useState, useEffect } from 'react'
import { Table, Card, CardBody, CardTitle } from 'reactstrap'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
const MySwal = withReactContent(Swal)

const ListaSolicitudes = () => {
  const [lista, setLista] = useState([])
  const getLista = () => {
    MySwal.fire({
      title: 'Ingrese password',
      input: 'password',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      showLoaderOnConfirm: true,
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.showLoading();
        MySwal.disableButtons();
        api.getLite(`solicitud.php?action=obtener_solicitudes&p=${result.value}`).then((resp) => {
          if (resp.status) {
            const li = resp.mensaje
            const laLista = []
            Object.entries(li).forEach(x => {
              laLista.push(x[1])
            })
            laLista.sort((a,b) => {
              return b.id - a.id
            })
            setLista(laLista)
          } else {
            MySwal.close()
            MySwal.fire(
              'No se pueden obtener los datos',
              'Error, ' + resp.mensaje,
              'error'
            )  
          }
        }).catch(error => {
          MySwal.fire(
            'No se pueden obtener los datos',
            'Error, consulte con el administrador del sitio!',
            'error'
          )
          MySwal.close()
        })
      }
    })
  }
  const numero = 1

  useEffect(() => {
    getLista()
  }, [numero])

	return (
		<div className="container" style={{paddingTop: '100px'}}>
      <div className="row">
        <div className="col-12">
          <Card>
            <CardBody className="text-center mt-4">
              <CardTitle>
                <h1>Lista de solicitudes Página Web</h1>
              </CardTitle>
            </CardBody>
          </Card>
        </div>
      </div>
      <br/>
        <div className="row">
          <div className="col-12">
            <Card>
              <CardBody>
                <div className="card card-6">
                  <div className="card-body">
                    <Table dark>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Fecha Creación</th>
                          <th>Empresa</th>
                          <th>Email</th>
                          <th>Dominio</th>
                          <th>Referencia</th>
                          <th>Contenido</th>
                          <th>Estructura</th>
                          <th>Hosting</th>
                          <th>Tipo Pagina</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          lista.map(x => (
                            <tr key={x.id}>
                              <th scope="row">{x.id}</th>
                              <td>{x.fecha_creacion}</td>
                              <td>{x.empresa}</td>
                              <td>{x.email}</td>
                              <td>{x.nombre_dominio}</td>
                              <td>{x.referencia}</td>
                              <td>{x.tiene_contenido}</td>
                              <td>{x.tiene_estructura}</td>
                              <td>{x.tiene_hosting}</td>
                              <td>{x.tipo_pagina}</td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </Table>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
        <br/><br/><br/>
        <br/><br/><br/>
    </div>
	)
}

export default ListaSolicitudes
